import { RouterLocation } from '@core/types'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const orderingPages = {
    OrderUserDetails: {
        path: routes.orderUserDetails.path,
        comp: () =>
            import('src/business/ordering/steps/invoicing-details/InvoicingDetailsOrderPage'),
        to: (): string => routes.orderUserDetails.path
    },
    OrderSummary: {
        path: routes.orderSummary.path,
        comp: () =>
            import('src/business/ordering/steps/summary/OrderSummaryPage'),
        to: (): string => routes.orderSummary.path
    },
    OrderOffer: {
        path: routes.orderOffer.path,
        comp: () => import('src/business/ordering/steps/OfferOrderPage'),
        to: (): string => routes.orderOffer.path
    },
    OrderOfferBox: {
        path: routes.orderOfferBox.path,
        comp: () => import('src/business/ordering/steps/OrderByBoxNamePage'),
        // to: (): string => routes.orderOfferBox.path
        to: (p: { boxName: number }): string => `/order/box/${p.boxName}`
    },
    OrderStatusCheck: {
        path: routes.orderStatusCheck.path,
        comp: () => import('src/business/ordering/OrderStatusCheckPage'),
        to: (): string => routes.orderStatusCheck.path
    }
}

const paths = new Set(Object.values(orderingPages).map(p => p.path))
export const isInOrderingProcess = (loc: RouterLocation) => paths.has(loc.path)
